const forms = require('./forms');

module.exports = (formElement, payload) => {
  // clear form validation first
  forms.clearFormErrors(formElement);
  $('.alert', formElement).remove();

  if (typeof payload === 'object' && payload.fields) {
    Object.keys(payload.fields).forEach((fieldName) => {
      const hasError = !!payload.fields[fieldName];
      if (hasError) {
        const $field = $(formElement).find(`[name="${fieldName}"]`);

        let errorMsg = payload.fields[fieldName];
        if (Array.isArray(errorMsg)) {
          errorMsg = errorMsg.join('<br/>');
        }

        forms.addFieldError($field, errorMsg);
      }
    });
  }
  if (payload?.error) {
    forms.addFormError(formElement, payload.error);
  }
};
